import React from 'react';
import Icon from '../../../components/AppIcon';


const MetricsPanel = ({ metrics, currentLanguage }) => {
  const translations = {
    en: {
      successRate: 'Success Rate',
      pendingMatches: 'Pending Matches',
      activePairings: 'Active Pairings',
      avgScore: 'Avg Match Score'
    },
    ko: {
      successRate: '성공률',
      pendingMatches: '대기 중 매칭',
      activePairings: '활성 페어링',
      avgScore: '평균 매칭 점수'
    }
  };

  const t = translations?.[currentLanguage];

  const metricCards = [
    {
      key: 'successRate',
      label: t?.successRate,
      value: `${metrics?.successRate}%`,
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      showProgress: true,
      progressValue: parseFloat(metrics?.successRate)
    },
    {
      key: 'pendingMatches',
      label: t?.pendingMatches,
      value: metrics?.pendingMatches,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      showProgress: false
    },
    {
      key: 'activePairings',
      label: t?.activePairings,
      value: metrics?.activePairings,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      showProgress: false
    },
    {
      key: 'avgScore',
      label: t?.avgScore,
      value: metrics?.avgMatchScore,
      icon: 'Target',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      showProgress: true,
      progressValue: parseFloat(metrics?.avgMatchScore) * 100
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metricCards?.map((metric) => (
        <div key={metric?.key} className="bg-card rounded-lg shadow-elevation-md p-4">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 ${metric?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={metric?.icon} size={20} className={metric?.color} />
            </div>
            <div className="text-right">
              <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
            </div>
          </div>
          <p className="text-sm font-medium text-muted-foreground mb-2">{metric?.label}</p>
          {metric?.showProgress && (
            <div className="w-full bg-muted/30 rounded-full h-2">
              <div
                className={`h-2 rounded-full transition-all ${metric?.color?.replace('text-', 'bg-')}`}
                style={{ width: `${Math.min(metric?.progressValue, 100)}%` }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;